import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/supplierLogin",
  name: "supplierLogin",
  component: function component() {
    return import("@/views/supplier/supplier-login.vue");
  },
  meta: {
    title: "确认登录",
    foot: true
  }
}, {
  path: "/supplierManage",
  name: "supplierManage",
  component: function component() {
    return import("@/views/supplier/supplier-manage.vue");
  },
  meta: {
    title: "供应链管理",
    foot: true
  }
}, {
  path: "/supplierApply",
  name: "supplierApply",
  component: function component() {
    return import("@/views/supplier/supplier-apply.vue");
  },
  meta: {
    title: "供应商入驻",
    foot: true
  }
}];